const FOCUSABLE =
  'button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function initializePurchaseModalFocus(root = document) {
  if (!root.body?.classList.contains('mhecomm-he-pdp-page')) return;
  root.addEventListener('shown.bs.modal', (event) => {
    const modal = event.target;
    if (!modal?.matches('.mhecomm-purchase-options .redi-modal-handle')) return;
    const focusTarget = modal.querySelector(`.modal-body ${FOCUSABLE}`) || modal.querySelector(FOCUSABLE);
    focusTarget?.focus();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializePurchaseModalFocus(), { once: true });
} else {
  initializePurchaseModalFocus();
}
